export default __webpack_public_path__ + "static/media/engine3.586cfc7c.jpg";